/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// eslint-disable-next-line no-undef
requirejs.config({
	paths: {
		'dashboard-analytics': 'js/dashboard-analytics',
		'dashboard-analytics-resources': 'dashboard-analytics',
		'@dashboard-features': 'js/dashboard-features',

		// VIPR3
		'has' : 'lib/requirejsdplugins/0.2.2-dev/has',
		'barejs' : 'js/vida/barejs/browser/bare.es5',
		'com/ibm/vipr' : 'js/vida/2.13/com/ibm/vipr',
		'com/ibm/vida' : 'js/vida/2.13/com/ibm/vida',

		// VIPR3 Debug
		//'com/ibm/vida/control/vida': 'js/vida/2.13/com/ibm/vida/control/vida.debug',
		//'com/ibm/vida/util/vidautils': 'js/vida/2.13/com/ibm/vida/util/vidautils.debug',
		//'com/ibm/vipr/VIPR': 'js/vida/2.13/com/ibm/vipr/VIPR.debug',

		// DataSources ambiguous connections or signons
		'datasource-signon': 'js/dashboard-analytics/lib/@waca/datasource-signon/src/datasource-signon',
		'drill-info-service': 'js/dashboard-analytics/lib/@waca/drill-info-service/src'
	},
	map: {
		'*': {

			'@waca/dashboard-common/js': 'dashboard-core/js/lib/@waca/dashboard-common/dist',
			'@waca/dashboard-livewidget/js': 'dashboard-analytics',
			'@waca/dashboard-livewidget/js/lib/@waca/core-client': 'baglass/core-client',

			// VIPR3 bundles
			'vizbundles': 'com/ibm/vida/vizbundles',

			'dashboard-analytics/lib/@waca/core-client': 'baglass/core-client',
			'dashboard-analytics/lib/@waca/baglass/js/baglass': 'baglass',

			'dashboard-analytics/lib/@waca/dashboard-common/dist/lib/@waca/core-client': 'baglass/core-client',
			'dashboard-analytics/lib/@waca/dashboard-common/dist/lib/@waca/baglass/js/baglass': 'baglass',
			'dashboard-analytics/lib/@waca/datasource-signon/src/datasource-signon/lib/@waca/core-client': 'baglass/core-client',
			'datasource-signon/lib/@waca/core-client': 'baglass/core-client',


			// We have a problem with dashboard-common model class being embedded in the live widget and in the dashboard common
			// Using different instances of the class is causing the generation of model idd to have colliding ids.
			// For Endor, we will remap the live widget embedded dashboard common to use the one embeded in the dashboard code
			// For anything in dashboard-common/dist/lib, we are getting them directly from live widget common lib
			'dashboard-analytics/lib/@waca/dashboard-common/dist/api': 'dashboard-core/js/lib/@waca/dashboard-common/dist/api',
			'dashboard-analytics/lib/@waca/dashboard-common/dist/core': 'dashboard-core/js/lib/@waca/dashboard-common/dist/core',
			'dashboard-analytics/lib/@waca/dashboard-common/dist/glass': 'dashboard-core/js/lib/@waca/dashboard-common/dist/glass',
			'dashboard-analytics/lib/@waca/dashboard-common/dist/query': 'dashboard-core/js/lib/@waca/dashboard-common/dist/query',
			'dashboard-analytics/lib/@waca/dashboard-common/dist/ui': 'dashboard-core/js/lib/@waca/dashboard-common/dist/ui',
			'dashboard-analytics/lib/@waca/dashboard-common/dist/utils': 'dashboard-core/js/lib/@waca/dashboard-common/dist/utils'
		}
	},
	bundles: {
		// this gets glass to pre-fetch these bundles which improves dashboard load performance.
		'barejs': [],
		'com/ibm/vipr/VIPR': []
	}
});
